const CONNECT_HR_API_URL = 'https://globalbackend-expressjs.onrender.com/api/connect-hr';

/**
 * Transport for HrContactLauncher/HrContactModal. Posts the callback
 * request to the Connect-HR backend endpoint.
 */
export const submitHrContactRequest = async (payload) => {
  try {
    const response = await fetch(CONNECT_HR_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok || data?.success === false) {
      return {
        success: false,
        message: data?.message || 'Something went wrong. Please try again.',
      };
    }

    return {
      success: true,
      message: data?.message,
    };
  } catch (error) {
    return {
      success: false,
      message: 'Network error. Please check your connection and try again.',
    };
  }
};
